import React from 'react'
import IconLarge from './icon-large.svg'
import IconRegular from './icon-regular.svg'
import IconSmall from './icon-small.svg'
import IconXlarge from './icon-xlarge.svg'
import IconXSmall from './icon-xsmall.svg'
import {Size} from './types'

const className = `
  fill-action-default
  text-background-secondary
  inline
  animate-spin
`

export const getIcon = (size: Size): JSX.Element => {
  switch (size) {
    case 'xsmall':
      return <IconXSmall className={className} />
    case 'small':
      return <IconSmall className={className} />
    case 'regular':
      return <IconRegular className={className} />
    case 'large':
      return <IconLarge className={className} />
    case 'xlarge':
      return <IconXlarge className={className} />
    default:
      return null
  }
}
